module.exports = __webpack_public_path__ + "img/latte_pack.636182db.png";